import { useComparisonTableDropdownIndices } from '@/decodo/blocks/ProductComparisonTable/comparisonUtils/utils';
import { Tooltip } from '@/decodo/components/atoms/Tooltip/Tooltip';
import React from 'react';
import ToolTipIcon from '~/icons/tooltip_icon.svg';
import {
  ComparisonText,
  ComparisonTextProps,
} from '../comparisonElements/ComparisonText';

interface ComparisonGridRowProps {
  title?: React.ReactNode;
  tooltip?: React.ReactNode;
  cellContents?: React.ReactNode[] | ComparisonTextProps[];
  visibleItemsCount: number;
}

export const ComparisonGridRow = ({
  title,
  tooltip,
  cellContents,
  visibleItemsCount,
}: ComparisonGridRowProps) => {
  const dropdownIndices = useComparisonTableDropdownIndices();

  return (
    <div className='grid grid-cols-[160px_repeat(3,_minmax(200px,_1fr))] pb-3'>
      <div className='group contents'>
        {/* Left title cell */}

        <div className='text-body-m-medium group-hover:bg-brand-100 group-hover:text-brand-900 flex gap-1 rounded-l bg-gray-50 py-2 pl-2 text-gray-500'>
          {title}
          {!!tooltip && (
            <Tooltip
              flowDirection='bottom-center'
              text={tooltip}
              classNames={{ text: 'max-w-52' }}
            >
              <ToolTipIcon className='hover:text-brand-900 text-brand-500 h-5 w-5' />
            </Tooltip>
          )}
        </div>

        {/* Product content cells */}
        {dropdownIndices.map((i) => {
          const shouldShowDash = i === visibleItemsCount;

          const isOmitted = visibleItemsCount < i;
          const content = cellContents?.[i];

          if (isOmitted) {
            return (
              <div
                key={`cell-${i}`}
                className='text-body-m group-hover:bg-brand-50 flex items-center rounded-r py-2 pl-12'
              />
            );
          }

          const cellContent =
            shouldShowDash || !content ? (
              <span className='text-body-m text-base-black'>–</span>
            ) : (
              <ComparisonText {...(content as ComparisonTextProps)} />
            );

          return (
            <div
              key={`cell-${i}`}
              className='text-body-m group-hover:bg-brand-50 flex items-center rounded-r py-2 pl-12'
            >
              {cellContent}
            </div>
          );
        })}
      </div>
    </div>
  );
};
export function MobileComparisonRow({
  left,
  right,
}: {
  left: React.ReactNode;
  right: React.ReactNode;
}) {
  return (
    <div className='text-body-m relative grid grid-cols-2 gap-4'>
      <div className='border-r border-gray-200 py-2 pl-2 pr-4'>{left} </div>
      <div className='py-2'>{right}</div>
    </div>
  );
}
